import React, { useEffect, useRef, useState } from "react";
import { Form as DhxForm } from "dhx-suite";

function getFormConfig(filterText: string) {
    return {
        padding: "8px 32px",
        rows: [
            {
                id: "text",
                type: "input",
                icon: "dxi dxi-magnify",
                placeholder: "Search for live examples",
                value: filterText
            }
        ]
    };
}

interface SearchInputProps {
    filterText: string;
    onChange: (text: string) => void;
}

export const SearchInput = ({ filterText, onChange }: SearchInputProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const [form, setForm] = useState<DhxForm>();

    useEffect(() => {
        if (ref.current && !form) {
            const theForm = new DhxForm(ref.current, getFormConfig(filterText));
            setForm(theForm);
        }

        if (form) {
            form.events.on("change", (_, value) => {
                onChange(value);
                setTimeout(() => {
                    (ref.current!.querySelector("input") as HTMLInputElement).focus();
                }, 0);
            });

            return () => form.events.detach("change");
        }

        return undefined;
    });

    useEffect(() => {
        if (form) {
            form.setConfig(getFormConfig(filterText) as any);
        }
    }, [filterText]);

    return <div className="st-search-input" ref={ref}></div>;
};
